export const looksLikeJson = (text: string) => {
	return text && ['[', '{'].includes(text[0])
}
export const looksLikeHtml = (text: string) => {
	return text?.includes('<html') || text?.includes('<HTML')
}
